import type { changeEmail, forgotPassword } from '@/types/common/confirmEmail'
import type { CreateUserPayload } from '@/types/models/User'
import Cookies from 'js-cookie'
import Bugsnag from '@bugsnag/js'

export const saveToken = (token: string, rememberMe?: boolean): void => {
  const expires = rememberMe ? 720 : undefined
  Cookies.set('access_token', token, { expires })
}

export const getToken = (): string | undefined => {
  return Cookies.get('access_token')
}

export const removeToken = (): void => {
  Cookies.remove('access_token')
  // Bugsnagのuser情報をクリア
  try {
    Bugsnag.setUser()
  } catch (error) {
    // Bugsnagが初期化されていない場合（ローカル環境など）はエラーを無視
    console.debug('Bugsnag user clearing failed:', error)
  }
}

// Register info
export const saveRegisterData = (text: string): void => {
  sessionStorage.setItem('register_info', text)
}

export const getRegisterData = (): CreateUserPayload => {
  return JSON.parse(sessionStorage.getItem('register_info') || '{}')
}

export const removeRegisterData = (): void => {
  sessionStorage.removeItem('register_info')
}

// Forgot Password
export const saveForgotPassword = (text: string): void => {
  localStorage.setItem('forgot_password', text)
}

export const getForgotPassword = (): forgotPassword => {
  return JSON.parse(localStorage.getItem('forgot_password') || '{}')
}

export const removeForgotPassword = (): void => {
  localStorage.removeItem('forgot_password')
}

// Change Email
export const saveChangeEmail = (text: string): void => {
  localStorage.setItem('change_email', text)
}

export const getChangeEmail = (): changeEmail | null => {
  const data = localStorage.getItem('change_email')
  return data ? JSON.parse(data) : null
}
export const removeChangeEmail = (): void => {
  localStorage.removeItem('change_email')
}
